import { MEDIA_QUERIES } from '../utils/breakpoints.js';

export function initCommonFunctions() {

    (function(){
        let anchorLinks = document.querySelectorAll('a[href^="#"]');
        anchorLinks.forEach((link) => {
            link.addEventListener("click", (e) => {
                const href = link.getAttribute('href');
                
                if (href === '#' || href === '') {
                    e.preventDefault();
                    return;
                }
    
                const targetId = href.substring(1);
                const targetElement = document.getElementById(targetId);
    
                if (targetElement) {
                    e.preventDefault();
                    targetElement.scrollIntoView({
                        // behavior: 'smooth'
                    });
                }
            });
        });
    })();


    (function(){
        let faqItems = $('.js-Faq');
        let faqToggle = faqItems.find('.question');        

        faqToggle.each((index, item) => {
            $(item).on('click', function() {
                $(this).siblings('.answer').slideToggle();
                $(this).toggleClass('is-Open');
            });
        });
    })();

    (() => {
        const $el_equipmentSlider = document.querySelector(".js-equipmentSlider");
        if (!$el_equipmentSlider) return;
        const swiper = new Swiper($el_equipmentSlider, {
            // centeredSlides: true,
            // loop: true,
            effect: "slide",
            navigation: {
                nextEl: ".modEquipmentSlider__nav--next",
                prevEl: ".modEquipmentSlider__nav--prev",
            },
            scrollbar: {
                el: '.modEquipmentSlider__scrollbar',
                draggable: true,
            },
            breakpoints: {
                1200: {
                    slidesPerView: 3,
                },
                769: {
                    slidesPerView: 2,
                },
                500: {
                    slidesPerView: 1.5,
                },
                320: {
                    slidesPerView: 1,
                },
            },
        });
    })();
}
